module.exports = __webpack_public_path__ + "img/gym.c6dddd9e.jpg";